/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { apiClient } from '../../adapters/api-client';
import { Department } from '../../adapters/api-client/referential/Referential.model';
import { ComboInput, ComboInputDS, DateInput, DateInputDS } from '../../components/DesignSystem';
import { useFetch } from '../../hooks/useFetch';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { BirthInfoModel, DepartmentItem } from '../../store/store.model';
import { checkBirthdayMajority, checkDateFullfilled, checkDateIsInTimeInterval } from '../../utils/DateUtils';
import { ValidityHtmlElement } from '../../utils/DsType';
import { formattedDepartments } from '../../utils/LocalityUtils';

const initBirthDepartment = { label: '', code: '', displayedLabel: '' };

// const ContainerCity = styled.div`
//   width: 100%;
//   .cities-list {
//     display: ${(props: any) => (props.displayCity ? 'flex' : 'none')};
//   }
// `;
const Naissance: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const {
    state: { holder },
    dispatch,
  } = useContext(store);
  const birthDateRef = useRef(null);
  const departmentRef = useRef(null);
  // const cityRef = useRef(null);
  const isFrench = holder?.identity?.birthCountry?.countryCode === 'FR';
  const { birthDate, birthDepartment } = (holder?.identity ?? {}) as BirthInfoModel;
  // const [cityItems, setCityItems] = useState<City[]>([]);
  const [departmentItems, setDepartmentItems] = useState<Department[]>([]);
  // const [displayCity, setDisplayCity] = useState<boolean>(birthDepartment?.code !== '');
  const { response: departments } = useFetch(() => apiClient().referential.getDepartments());
  // on birthDate change
  const onBirthDateChange = (e: Event & { detail?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { identity: { birthDate: e.detail?.value } } }));
  };
  // BirthDate EVENTS AND VALIDATION
  useEffect(() => {
    if (!!birthDateRef && birthDateRef.current !== null) {
      (birthDateRef.current as unknown as DateInputDS).customValidityPattern = [
        {
          regexp: () => checkBirthdayMajority(18, (birthDateRef.current as unknown as DateInputDS).date),
          errorMessage: 'Vous devez être majeur pour souscrire un crédit.',
        },
        {
          regexp: () => checkDateIsInTimeInterval((birthDateRef.current as unknown as DateInputDS).date),
          errorMessage: 'Vérifiez votre année de naissance, elle ne semble pas exacte.',
        },
        {
          regexp: () => checkDateFullfilled((birthDateRef.current as unknown as DateInputDS)?.value as string),
          errorMessage: 'Le format de votre date de naissance est incorrect (ex: 01/01/1980).',
        },
        { regexp: '.+', errorMessage: 'Veuillez renseigner votre date de naissance.' },
      ];
    }
    return;
  }, []);

  useEffect(() => {
    if (departments) {
      setDepartmentItems(formattedDepartments(departments));
    }
  }, [departments]);
  // select department
  const departmentOnListSelect = (event: Event) => {
    const selectedDept = (event as CustomEvent).detail.value as DepartmentItem;
    dispatch(
      updateStore({
        holder: {
          identity: {
            birthDepartment: selectedDept,
            // , birthCity: initBirthCity
          },
        },
      }),
    );
    // setDisplayCity(true);
  };
  // on blur department
  const onBlurDepartment = (event: Event) => {
    if (departmentRef.current && departmentRef.current !== null) {
      if (event && event.target && (event.target as unknown as ComboInputDS).value === '') {
        (departmentRef.current as unknown as ValidityHtmlElement).valid = false;
        dispatch(
          updateStore({
            holder: {
              identity: {
                birthDepartment: initBirthDepartment,
                // , birthCity: initBirthCity
              },
            },
          }),
        );
        // setDisplayCity(false);
      }
    }
  };
  const onLetterChangeDepartment = () => {
    if (departmentRef.current && departmentRef.current !== null) {
      (departmentRef.current as unknown as ValidityHtmlElement).valid = false;
      dispatch(
        updateStore({
          holder: {
            identity: {
              birthDepartment: initBirthDepartment,
              // , birthCity: initBirthCity
            },
          },
        }),
      );
      // setDisplayCity(false);
    }
  };
  // DEPARTMENT EVENTS AND VALIDATION
  useEffect(() => {
    if (!!departmentRef && departmentRef.current !== null) {
      (departmentRef.current as unknown as ComboInputDS).filtration = ({
        displayedLabel,
      }: {
        displayedLabel: string;
      }) => {
        const labelElements: string[] = displayedLabel.split(' - ');
        const regex = new RegExp(
          `^${((departmentRef.current as unknown as ComboInputDS).value as string).toLowerCase()}`,
        );

        if (labelElements.length !== 2) return false;
        return (
          regex.test(String(labelElements[0]).toLowerCase()) ||
          regex.test(String(labelElements[1]).toLowerCase()) ||
          regex.test(String(displayedLabel).toLowerCase())
        );
      };

      (departmentRef.current as unknown as ComboInputDS).customValidityPattern = [
        {
          regexp: () => (departmentRef.current as unknown as ValidityHtmlElement).checkComboValidity(),
          errorMessage: 'Veuillez vérifier votre département de naissance.',
        },

        { regexp: '.+', errorMessage: 'Veuillez renseigner votre département de naissance.' },
      ];
    }
    return;
  }, []);

  //select city
  // const cityOnListSelect = (event: Event) => {
  //   const selectedCity = (event as CustomEvent).detail.value as CityItem;
  //   dispatch(updateStore({ birthInfo: { birthCity: selectedCity } }));
  // };
  // const loadCities = async (departmentCode: string) => {
  //   const cities = await apiClient().referential.getDepartementCities(departmentCode);
  //   if (cities) {
  //     setCityItems(cities);
  //   }
  // };
  // useEffect(() => {
  //   if (displayCity && birthDepartment?.code) {
  //     loadCities(birthDepartment.code);
  //   }
  // }, [displayCity]);
  // CITY EVENTS AND VALIDATION COMBO
  // useEffect(() => {
  //   if (!!cityRef && cityRef.current !== null) {
  //     (cityRef.current as unknown as ComboInputDS).customValidityPattern = [
  //       {
  //         regexp: () => (cityRef.current as unknown as ValidityHtmlElement).checkComboValidity(),
  //         errorMessage: "L'information saisie est incorrecte.",
  //       },
  //       { regexp: '.+', errorMessage: 'Veuillez renseigner votre ville de naissance.' },
  //     ];
  //   }
  //   return;
  // }, [displayCity]);
  // on change city
  // const onBirthCityChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
  //   const cityInputValue: CityItem = {
  //     department: '',
  //     inseeNumber: '',
  //     name: (e as CustomEvent).detail.value,
  //     zipCode: '',
  //   };
  //   dispatch(updateStore({ holder: { birthInfo: { birthCity: cityInputValue } } }));
  // };
  return (
    <>
      <DateInput
        ref={birthDateRef}
        required
        class="to-validate trackable-blur"
        label="Date de naissance"
        value={birthDate}
        onInputChange={onBirthDateChange}
        onLetterChanged={onBirthDateChange}
      ></DateInput>
      {isFrench && (
        <>
          <ComboInput
            ref={departmentRef}
            list-on-open
            shadow
            align-items="left"
            items={JSON.stringify(departmentItems)}
            class="to-validate trackable-blur"
            field="displayedLabel"
            label="Département de naissance"
            placeholder="59 - Nord"
            maxLength="32"
            onListBlur={onBlurDepartment}
            onSelectedList={departmentOnListSelect}
            onLetterChanged={onLetterChangeDepartment}
            value={birthDepartment?.displayedLabel || ''}
          ></ComboInput>
          {/* <ContainerCity {...{ displayCity }}>
            <ComboInput
              ref={cityRef}
              list-on-open
              shadow
              align-items="left"
              items={JSON.stringify(cityItems)}
              class="to-validate trackable-blur cities-list"
              field="name"
              label="Ville de naissance "
              placeholder="Lille"
              maxLength="32"
              onSelectedList={cityOnListSelect}
              value={birthCity?.name || ''}
            ></ComboInput>
          </ContainerCity> */}
        </>
      )}
      {/* )} */}
    </>
  );
};

export default Naissance;
